import { ScoreResponse, WordScore } from 'utils/types'
import api from '../../api/api'

export const asyncGetReadingScore = async (
  bookId: string | null | undefined,
  filePath: Blob,
  sentence: string,
  options?: {
    isPlacementTest?: boolean
    isPracticePage?: boolean
    isReadingLevelUp?: boolean
    studySetId?: string
    lessonInstanceId?: string
    activityReference?: string
    exerciseId?: string
    wordsPracticeIndex?: number
    useOpenEndpoint?: boolean
    conversationIndex?: number
  }
): Promise<{ score: number; wordScores: WordScore[] }> => {
  const formData = new FormData()
  // const audio = { name: 'astrid_recording', type: 'audio/m4a', uri: filePath }

  // For some reason the formData.append stopped accepting a JS object or boolean values
  // Everything works though, but I wasnt able to find the cause. Will have to investigate further
  // TODO: Find out why TS complains when appending objects and booleans to FormData

  formData.append('dialect', 'US')
  formData.append('target_phrase', sentence)
  // @ts-ignore
  formData.append('audio', filePath)

  if (!options?.isPlacementTest && !options?.isReadingLevelUp && !options?.studySetId && !!bookId) {
    formData.append('bookId', bookId)
  }

  if (options?.isPracticePage) {
    // @ts-ignore
    formData.append('isPracticePage', true)
  }

  if (options?.isReadingLevelUp) {
    // @ts-ignore
    formData.append('isReadingLevelUp', true)
  }

  if (options?.lessonInstanceId) {
    formData.append('routineId', options.lessonInstanceId)
  }

  if (options?.activityReference) {
    formData.append('activityReference', options.activityReference)
  }

  if (options?.studySetId) {
    formData.append('studySetId', options.studySetId)
  }

  if (options?.exerciseId) {
    formData.append('exerciseId', options.exerciseId)
  }

  if (options?.wordsPracticeIndex !== undefined) {
    // @ts-ignore
    formData.append('wordsPracticeIndex', options.wordsPracticeIndex)
  }

  if (typeof options?.conversationIndex === 'number') {
    // @ts-ignore
    formData.append('conversationIndex', options.conversationIndex)
  }

  const { data } = await api.post<ScoreResponse>(
    options?.useOpenEndpoint ? '/astrid/public/score' : '/astrid/score',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )

  return {
    score: data.overall_score,
    wordScores: data.word_scores
  }
}

export const getWordSize = (length: number) => {
  if (length > 24)
    return {
      fontSize: '24px',
      lineHeight: '28px'
    }

  if (length > 16)
    return {
      fontSize: '28px',
      lineHeight: '32px'
    }

  if (length > 12)
    return {
      fontSize: '40px',
      lineHeight: '44px'
    }

  return {
    fontSize: '48px',
    lineHeight: '56px'
  }
}

export const getScoreColor = (score?: number) => {
  if (score === undefined) return '#000'

  if (score >= 80) return '#5DDFB1'

  if (score < 50) return '#F76988'

  return '#ffdc4a'
}
